import React, { Fragment } from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  CardActions,
  ListButton,
  ReferenceInput,
  SelectInput,
  FormDataConsumer,
  BooleanInput,
} from 'react-admin';
import ShowButton from './ShowButton';
import SaveOnlyToolbar from '../SaveOnlyToolbar';

import { validateOffer } from '../../validators';

const Title = ({ record }) => (
  <span>Offer: <strong>{record.name}</strong></span>
);


const Actions = ({ basePath, data, path }) => (
  <CardActions>
    <ShowButton basePath={basePath} record={data} path={path} />
    <ListButton basePath={basePath} />
  </CardActions>
);

const solicitedAdmin = choice => `${choice.email} (${choice.role})`;

export default props => (
  <Edit
    {...props}
    title={<Title />}
    actions={<Actions path={props.location.pathname} />}
    undoable={false}
  >
    <TabbedForm toolbar={<SaveOnlyToolbar />} validate={validateOffer}>
      <FormTab label="Details">
        <ReferenceInput
          source="solicitedBy"
          reference="users"
          label="SolicitedBy"
          basePath="users"
          filter={{ role: '_not_null_' }}
        >
          <SelectInput
            optionText={solicitedAdmin}
          />
        </ReferenceInput>
        <FormDataConsumer>
          {({ formData, record }) => (formData.endStatus && (
            <Fragment>
              <div>
                <SelectInput
                  source="endStatus"
                  label="Order Status"
                  disabled={!formData.overrideEndStatus}
                  choices={[
                      { id: 'approved', name: 'Approved' },
                      { id: 'rejected', name: 'Rejected' },
                      { id: 'cancelled', name: 'Cancelled' },
                    ]}
                  validate={value => (formData.overrideEndStatus && value === record.endStatus ? 'The value cannot be the same since you chose to override it.' : null)}
                />
                <BooleanInput
                  label="Override Status"
                  name="overrideEndStatus"
                  defaultValue={!!formData.overrideEndStatus}
                  style={{ display: 'inline-block', marginLeft: 15 }}
                  onChange={(event) => {
                    if (!event.target.checked) {
                      // eslint-disable-next-line no-param-reassign
                      formData.endStatus = record.endStatus;
                      // eslint-disable-next-line no-param-reassign
                      delete formData.sendEmail;
                    }
                    // eslint-disable-next-line no-param-reassign
                    formData.overrideEndStatus = event.target.checked;
                  }}
                />
              </div>
              <div>
                <BooleanInput
                  label="Send email on status change?"
                  source="sendEmail"
                  style={{ display: !formData.overrideEndStatus ? 'none' : 'flex' }}
                />
              </div>
            </Fragment>
          ))}
        </FormDataConsumer>
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/Edit.js